import { trpc } from "../../utils/trpc"

export const useAddSlideTrpc = () => {
  const utils = trpc.useContext()
  return trpc.listeningPostSlide.addSlide.useMutation({
    onSuccess: (_, {namespaceId, listeningPostId}) => {
      utils.listeningPost.id.invalidate({namespaceId, id: listeningPostId})
    }
  })
}